import React, { useEffect, useRef, useState } from 'react'
import {Box, Grid, GridItem, Heading, Image, Input, Select, Tooltip,Text, RangeSlider, RangeSliderFilledTrack, RangeSliderThumb, RangeSliderTrack} from '@chakra-ui/react'
import CustomButton from '../../../elements/customButton'
import { bindActionCreators } from 'redux'
import { connect, useSelector } from 'react-redux'
import { ActionCreators } from '../../../../redux/actions'
import CustomToast from '../../../elements/customToast'
import Loader from '../../../elements/loader'
import AddIcon from '../../../../assets/images/addFile.svg'
import EquifaxIcon from '../../../../assets/images/equifax.svg'
import NavBar from '../../../elements/NavBar'
import {useHistory} from 'react-router-dom'
import { getItem, removeItem } from '../../../../utilities/authUtils'
import * as routesNames from '../../../../constants/routes'
import moment from 'moment'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { error } from 'pdf-lib'
import { preventInvalidKey } from "../../../../utilities/CustomFunctions.js";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
const OnBoardApplyLoan = (props) => {

  const CREDITSCORE = getItem('score')
  const BORROWERNUMBER = getItem('borrower_phone')
  const BORROWERNAME = getItem('name')
  const employmentType = getItem('employment_type_apply')
  const history = useHistory()
  const {addToast} = CustomToast()
  const adminState = useSelector((state) => state.adminState)
  const masterState = useSelector((state) => state.masterState)
  const borrowerState = useSelector((state) => state.borrowerState)
  const cpState = useSelector((state) => state.cpState)
  const bankRef = useRef()
  const incomeRef = useRef()
  const itrRef = useRef()
  const cpAssesmentRef = useRef()
  const InvoiceRef = useRef()
  const BankStatRef = useRef()
  const PrrofdelliveryRef = useRef()
  const gstSubmissionRef = useRef()
  const pdcRef = useRef()
  const [inputValues, setInputValues] = useState({})
  const [bankStatement, setBankStatement] = useState(null)
  const [incomeStatement, setIncomeStatement] = useState(null)
  const [itrStatement, setItrStatement] = useState(null)
  const [cpAssesment, setCpAssesment] = useState(null)
  const [BankStatement2Statement, setBankStatement2Statement] = useState(null)
  const [Proof_DeliveryStatement, setProof_DeliveryStatement] = useState(null)
  const [InvoiceStatement, setInvoiceStatement] = useState(null)
  const [GstPaidStatement, setGstPaidStatement] = useState(null)

  const [pdcData, setPdcData] = useState(null)
  const [expectedROI, setExpectedROI] = useState({roi: [0, 23]});
  const [score, setScore] = useState(0)
  const [selectedLoanType, setSelectedLoanType] = useState(null);
  const [loanTenure, setLoanTenure] = useState([0, 0])
  const [loanRange, setLoanRange] = useState(null)
  const [is_bank_StatementProtected, setIs_bank_StatementProtected] = useState(false);
  const [is_bank_Statement2Protected, setIs_bank_Statement2Protected] = useState(false);
  const [is_Income_Protected, setIs_Income_Protected] = useState(false);
  const [is_Itr_Protected, setIs_Itr_Protected] = useState(false);
  const userData = adminState?.getUserByToken?.data?.data
  const dropdownData = masterState?.getDropdownData?.data?.data
  const productData = borrowerState?.getProductList?.data?.data
  const productdatamap =productData && productData.length > 0 && productData.map(item=>item?.product_id)
  const loanTenureData = selectedLoanType?.max_tenure_limit && JSON.parse(selectedLoanType?.max_tenure_limit)
  
    useEffect(() => {
        setTimeout(() => {
            if(CREDITSCORE){
                setScore(CREDITSCORE);
            } else{
                setScore(0);
            }
        }, 2000)
    }, [])

    useEffect(() => {
        props.actions.getUserByTokenAction()
        props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership',platform:"web",employment_type:employmentType})
        // props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership' ,platform:"web",employment_type:emp_get})
        props.actions.getProductListAction({platform:"web",employment_type:employmentType})
    }, []);

    useEffect(() => {
        if (cpState?.createLoan?.data?.success === true){
            addToast({message: cpState?.createLoan?.data?.message, status: 'success'})
            props?.actions?.cleanUpToast()
            setInputValues({})
            setBankStatement(null)
            setIncomeStatement(null)
            setItrStatement(null)
            setCpAssesment(null)
            setInvoiceStatement(null)
            setGstPaidStatement(null)
            setBankStatement2Statement(null)
            // setBranchAssesment(null)
            setSelectedLoanType(null)
            setProof_DeliveryStatement(null)
            removeItem('borrower_phone')
        props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership' ,platform:"web",employment_type:employmentType})
            history.push(routesNames.CPBORROWERS)
        } else if (cpState?.createLoan?.data?.success === false){
            addToast({message: cpState?.createLoan?.data?.message, status: 'error'})
            props?.actions?.cleanUpToast()
            props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership',platform:"web",employment_type:employmentType})
        }
    }, [cpState?.createLoan?.data])

  const calculateRotation = () => {
    if (score === 0 || (score >= 1 && score <= 299)) {
      return 0;
    }
    const minScore = 300;
    const maxScore = 900;
    const rotationRange = 225;
    const min = (score - minScore)
    const max = (maxScore - minScore);
    const percentage = min / max
    const rotation = percentage * rotationRange;
    return rotation;
  }
  const rotationNumber = calculateRotation()

  const getStatus = (score) => {
    if (score >= 1 && score <= 299) {
      return { className: 'poor', text: 'Poor' };
    } else if (score >= 300 && score <= 550) {
      return { className: 'poor', text: 'Poor' };
    } else if (score >= 551 && score <= 650) {
      return { className: 'average', text: 'Average' };
    } else if (score >= 651 && score <= 750) {
      return { className: 'fair', text: 'Fair' };
    } else if (score >= 751 && score <= 900) {
      return { className: 'excellent', text: 'Excellent' };
    } else {
      return { className: '', text: '' };
    }
  }
  const { className, text } = getStatus(score)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prevValues) => {
        let updatedValues = { ...prevValues, [name]: value };
    
        // Handle 'invoice_issue_date'
        if (name === "invoice_issue_date") {
          updatedValues.invoice_issue_date = moment(value).format('YYYY-MM-DD');
        }
    
        // Handle 'invoice_payment_date'
        if (name === "invoice_payment_date") {
          updatedValues.invoice_payment_date = moment(value).format('YYYY-MM-DD');
        }
    
        // Calculate 'credit_period' if both dates are present
        if (updatedValues.invoice_issue_date && updatedValues.invoice_payment_date) {
          updatedValues.credit_period = moment(updatedValues.invoice_payment_date).diff(
            moment(updatedValues.invoice_issue_date),
            'days'
          );
        }
    if (name === 'loan_amount') {
      const loanAmount = parseInt(value, 10);
      const loanRange = loanTenureData?.find((range) => loanAmount >= parseInt(range?.min_amount) && loanAmount <= parseInt(range?.max_amount));
      setLoanRange({
        min_tenure: loanRange ? parseInt(loanRange.min_tenure) : 0,
        max_tenure: loanRange ? parseInt(loanRange.max_tenure) : 0,
      });
      // Reset loan tenure when loan amount changes
      setLoanTenure([loanRange ? parseInt(loanRange.min_tenure) : 0, loanRange ? parseInt(loanRange.max_tenure) : 0]);
    } else if (name === 'loan_type') {
        const data = productData.find((item) => item.product_id === Number(value))        
        setSelectedLoanType(data);
        setInputValues({});
        setLoanTenure([0, 0]);
        setLoanRange(null);
        setBankStatement(null);
        setIncomeStatement(null);
        setItrStatement(null);
        setCpAssesment(null);
        // setBranchAssesment(null);
    }
    return updatedValues;
});
  }

  const showOpenFileDialog = (type) => {
    if (type === 'bank_statement') {
      bankRef.current.click()
      return
    }
    if (type === 'income_proof') {
      incomeRef.current.click()
      return
    }
    if (type === 'itr_proof') {
      itrRef.current.click()
      return
    }
    if (type === 'cp_assesment') {
      cpAssesmentRef.current.click()
      return
    }
    if (type === 'invoice_copy') {
        InvoiceRef.current.click()
        return
      }
      if (type === 'gst_paid_submission') {
        gstSubmissionRef.current.click()
        return
      }
      if (type === 'proof_of_delivery') {
        PrrofdelliveryRef.current.click()
        return
      }
      if (type === 'bank_statement_2') {
        BankStatRef.current.click()
        return
      }
    if (type === 'pdc') {
      pdcRef.current.click()
      return
    }
  }


  const checkPDFProtection = (file) => {
    if (!(file instanceof Blob)) {
      return Promise.reject(new Error("Invalid file type. Expected a Blob or File."));
    }
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = async function () {
        const typedarray = new Uint8Array(this.result);
  
        try {
          await pdfjsLib.getDocument({ data: typedarray }).promise;
          resolve(false); // Not protected
        } catch (error) {
          if (error?.name === 'PasswordException') {
            resolve(true); // Protected
          } else {
            console.error('PDF parsing error:', error);
            reject(error);
          }
        }
      };
      fileReader.onerror = (err) => reject(err);
      fileReader.readAsArrayBuffer(file);
    });
  };


const onChangeFile = async (e, type) => {
  const file = e.target.files[0];
  if (!file) return;

  if (file.type !== 'application/pdf') {
    addToast({ message: `${type.replace(/_/g, ' ')} must be a file of type: PDF.`, status: 'error' });
    return;
  }

  try {
    const isProtected = await checkPDFProtection(file);
    console.log(`${type} isProtected:`, isProtected);

    // Always reset the relevant protection state first
    switch (type) {
      case "bank_statement":
        setIs_bank_StatementProtected(isProtected);
        if (isProtected)
          addToast({ message: 'Bank Statement is password-protected please enter your password.', status: 'warning' });
        break;
      case "bank_statement_2":
        setIs_bank_Statement2Protected(isProtected);
        if (isProtected)
          addToast({ message: 'Financial Year Bank Statement is password-protected please enter your password.', status: 'warning' });
        break;
      case "income_proof":
        setIs_Income_Protected(isProtected);
        if (isProtected)
          addToast({ message: 'Income Proof is password-protected please enter your password.', status: 'warning' });
        break;
      case "itr_proof":
        setIs_Itr_Protected(isProtected);
        if (isProtected)
          addToast({ message: 'ITR Proof is password-protected please enter your password.', status: 'warning' });
        break;
      default:
        break;
    }
  } catch (err) {
    console.error("Error checking PDF protection:", err);
    addToast({ message: 'Something went wrong while checking the PDF please enter your password.', status: 'error' });
    return;
  }

  // Set file
  switch (type) {
    case 'income_proof':
      setIncomeStatement(file);
      break;
    case 'itr_proof':
      setItrStatement(file);
      break;
    case 'bank_statement':
      setBankStatement(file);
      break;
    case 'bank_statement_2':
      setBankStatement2Statement(file);
      break;
    case 'invoice_copy':
      setInvoiceStatement(file);
      break;
    case 'gst_paid_submission':
      setGstPaidStatement(file);
      break;
    case 'proof_of_delivery':
      setProof_DeliveryStatement(file);
      break;
    case 'pdc':
      setPdcData(file);
      break;
    case 'cp_assesment':
      setCpAssesment(file);
      break;
    default:
      addToast({ message: 'Unsupported document type.', status: 'error' });
  }
};

  const handleExpectedROI = (e, type) => {
    const updatedDetails = {...expectedROI, [type]: e,}
    setExpectedROI(updatedDetails)
  }

  const handleLoanTenure = (e) => {
    if (loanTenureData) {
      if (inputValues?.loan_amount) {
        let temp = [];
        temp[0] = 3;
        temp[1] = e[1];
        setLoanTenure(temp)
      } else {
        addToast({message: 'Please Enter Loan Amount', status: 'error'})
        return
      }
    }
  }
  const tryOpenPDFWithPassword = (file, password) => {
    if (!(file instanceof Blob)) {
      return Promise.reject(new Error("Invalid file type. Expected a Blob or File."));
    }
  
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
  
      fileReader.onload = async function () {
        const typedarray = new Uint8Array(this.result);
  
        try {
          await pdfjsLib.getDocument({
            data: typedarray,
            password
          }).promise;
  
          resolve(true); // Password correct
        } catch (error) {
          if (error?.name === 'PasswordException') {
            resolve(false); // Wrong password
          } else {
            console.error('PDF open error:', error);
            reject(error);
          }
        }
      };
  
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(file);
    });
  };
  
const handleValidatedLoanApply = async (productId, frequency, tenureLimit) => {
  const passwordChecks = [
    { type: 'bank_statement', isProtected: is_bank_StatementProtected, password: inputValues.bank_stmt1_password },
    { type: 'bank_statement_2', isProtected: is_bank_Statement2Protected, password: inputValues.bank_stmt2_password },
    { type: 'income_proof', isProtected: is_Income_Protected, password: inputValues.salary_slip_1_password },
    { type: 'itr_proof', isProtected: is_Itr_Protected, password: inputValues.itr_form16_password },
  ];

  for (const check of passwordChecks) {
    if (check.isProtected && !check.password) {
      addToast({ message: `Please enter password for ${check.type.replace(/_/g, ' ')}`, status: 'error' });
      return;
    }

    if (check.isProtected && check.password) {
      const fileMap = {
        'bank_statement': bankStatement,
        'bank_statement_2': BankStatement2Statement,
        'income_proof': incomeStatement,
        'itr_proof': itrStatement,
      };

      const file = fileMap[check.type];
      const valid = await tryOpenPDFWithPassword(file, check.password);
      if (!valid) {
        addToast({ message: `Incorrect password for ${check.type.replace(/_/g, ' ')}`, status: 'error' });
        return;
      }
    }
  }

  handleApplyLoan(productId, frequency, tenureLimit);
};
  const handleApplyLoan = async(max_tenure_lim,password,type) => {
    if (!selectedLoanType?.product_id) {
      addToast({message: 'Please Select Loan Type', status: 'error'})
      return
    }
    
    if(selectedLoanType?.product_id == "17"){
        if (!inputValues?.invoice_amount) {
            addToast({message: 'Please Enter Invoice Amount', status: 'error'})
            return
          }
         
          if (Number(inputValues?.invoice_amount) <=0) {
            addToast({message: 'Please Enter Valid Invoice invoice loan amount' , status: 'error'});
            return
          }
         
          if (Number(inputValues?.loan_amount) < 10000) {
            addToast({message: 'Minimum loan amount is ₹10000', status: 'error'});
            return
          }
          if (Number(inputValues?.loan_amount )> 300000) {
            addToast({message: 'Maximum loan amount is ₹300000', status: 'error'});
            return
          }
          if (!inputValues?.loan_tenure) {
            addToast({message: 'Please Enter Your Loan Tenure', status: 'error'})
            return
          }
          if ((inputValues?.loan_tenure > 90 || inputValues?.loan_tenure == 0) ) {
            addToast({message: 'Please Enter Tenure Between 15 Days to 90 Days ', status: 'error'})
            return
          }
          if (!inputValues?.invoice_issue_date) {
            addToast({message: 'Please Select Your Invoice Issue Date', status: 'error'})
            return
          }
          if (!inputValues?.invoice_payment_date) {
            addToast({message: 'Please Select Your Invoice Payment Date', status: 'error'})
            return
          }
          if (!inputValues?.credit_period || !inputValues?.credit_period > 90 ) {
            addToast({message: 'Please Enter  Credit Period', status: 'error'})
            return
          }
         
          if ( inputValues?.credit_period <= 0 ) {
            addToast({message: 'Please Enter Valid Credit Period', status: 'error'})
            return
          }
          if ( inputValues?.credit_period > 90 ) {
            addToast({message: 'Please Select Valid Credit Period Upto 90 Days', status: 'error'})
            return
          }
         
          if (!inputValues?.company_establishment) {
            addToast({message: 'Please Select Total Company Establishment', status: 'error'})
            return
          }
         
          if (!inputValues?.avg_annual_turnover) {
            addToast({message: 'Please Enter Average Turn Over', status: 'error'})
            return
          }
          if (!inputValues?.buss_premise_ownership) {
            addToast({message: 'Please Enter House Ownership', status: 'error'})
            return
          }
    }
    else if(selectedLoanType?.product_id == '10 '){
        if (Number(inputValues?.loan_amount) < 100000) {
            addToast({message: 'Minimum loan amount is ₹100000', status: 'error'});
            return
          }
          if (Number(inputValues?.loan_amount) > 1000000) {
            addToast({message: 'Maximum loan amount is ₹300000', status: 'error'});
            return
          }
          if (!inputValues?.company_establishment) {
            addToast({message: 'Please Select Total Company Establishment', status: 'error'})
            return
          }
         
          if (!inputValues?.avg_annual_turnover || inputValues?.avg_annual_turnover < 100000) {
            addToast({message: 'Please Enter Average Turn Over', status: 'error'})
            return
          }
          if (!inputValues?.buss_premise_ownership) {
            addToast({message: 'Please Enter House Ownership', status: 'error'})
            return
          }
          if (!inputValues?.loan_tenure || inputValues?.loan_tenure < 6  || inputValues?.loan_tenure > 36 ) {
            addToast({message: 'Please Enter Your Valid Tenure', status: 'error'})
            return
          }
          if (!inputValues?.loan_purpose) {
            addToast({message: 'Please Select Loan Purpose', status: 'error'})
            return
          }
    }
    else {
            if (!inputValues?.loan_purpose) {
                addToast({message: 'Please Select Loan Purpose', status: 'error'})
                return
              }
              if ((selectedLoanType?.product_id === 3 || selectedLoanType?.product_id=== 2) && !inputValues?.loan_tenure) {
                addToast({message: 'Please Enter Your Loan Tenure', status: 'error'})
                return
              }
              if (Number(!inputValues?.loan_amount)) {
                addToast({message: 'Please Enter Your Loan Amount', status: 'error'});
                return
              }
              if (!inputValues?.educational_qualification) {
                addToast({message: 'Please Enter Education Qualification', status: 'error'})
                return
              }
              if (!inputValues?.current_company_name) {
                addToast({message: 'Please Enter Current Company Name', status: 'error'})
                return
              }
              if (!inputValues?.company_sector) {
                addToast({message: 'Please Select Company Sector', status: 'error'})
                return
              }
              if (!inputValues?.work_experience) {
                addToast({message: 'Please Select Total Work Experience', status: 'error'})
                return
              }
              if (!inputValues?.monthly_income) {
                addToast({message: 'Please Enter Monthly Income', status: 'error'})
                return
              }
              if (!inputValues?.premise_status) {
                addToast({message: 'Please Enter House Ownership', status: 'error'})
                return
              }
        
    }
    const fileMap = {
      'income_proof': incomeStatement,
      'itr_proof': itrStatement,
      'bank_statement': bankStatement,
      'bank_statement_2': BankStatement2Statement,
    };
  
    const file = fileMap[type];
    // if (!file?.income_proof || !file?.bank_statement) {
    //   addToast({ message: 'File not found for validation.', status: 'error' });
    //   return;
    // }
    try {
      const isPasswordCorrect = await tryOpenPDFWithPassword(file, password);
      if (!isPasswordCorrect) {
        addToast({ message: 'Incorrect password. Please try again.', status: 'error' });
      } else {
        addToast({ message: 'PDF unlocked successfully.', status: 'success' });
  
        switch (type) {
          case "bank_statement":
            setIs_bank_StatementProtected(false);
            break;
          case "bank_statement_2":
            setIs_bank_Statement2Protected(false);
            break;
          case "income_proof":
            setIs_Income_Protected(false);
            break;
          case "itr_proof":
            setIs_Itr_Protected(false);
            break;
        }
      }
    } catch (err) {
      console.error("PDF open failed:", err);
    }
    if (is_bank_StatementProtected && !inputValues?.bank_stmt1_password) {
      addToast({message:'Please enter your bankstatement password for protected PDF.',status: "error"});
      return;
    }
    if (is_bank_Statement2Protected && !inputValues?.bank_stmt2_password) {
      addToast({message:'Please enter your financial year bankstatement password for protected PDF.',status: "error"});
      return;
    }
    
    if (is_Income_Protected && !inputValues?.salary_slip_1_password) {
      addToast({message:'Please enter your income password for protected PDF.',status: "error"});
      return;
    }
   if (is_Itr_Protected && !inputValues?.itr_form16_password) {
      addToast({message:'Please enter your itr  password for protected PDF.',status: "error"});
      return;
    } 
    let formData = new FormData();
    formData.append("invoice_amount", inputValues?.invoice_amount);
    formData.append("loan_type", selectedLoanType?.product_id);
    formData.append("loan_amount", inputValues?.loan_amount);
    // formData.append("tenure",  max_tenure_lim ? loanTenure[1] : inputValues?.loan_tenure);
    formData.append("tenure",  !loanTenureData ? inputValues?.loan_tenure : loanTenure[1]);
    formData.append("loan_purpose", inputValues?.loan_purpose);
    formData.append("premise_status", inputValues?.premise_status ?? userData?.personal_data?.premise_status);
    formData.append("educational_qualification", inputValues?.educational_qualification ?? userData?.personal_data?.educational_qualification);
    formData.append("company_name", inputValues?.current_company_name);
    formData.append("company_sector", inputValues?.company_sector);
    formData.append("work_exp_level", inputValues?.work_experience);
    formData.append("net_monthly_income", inputValues?.monthly_income);
    formData.append("disbursal_consent", 'Y');
    formData.append('bank_statement_1', bankStatement ?? null)
    formData.append('itr_form16', itrStatement ?? null)
    formData.append('salary_slip_1', incomeStatement ?? null)
    formData.append('cp_credit_assessment', cpAssesment ?? null)
    formData.append('post_dated_cheque', pdcData ?? null)
    formData.append("invoice_copy", InvoiceStatement);
    formData.append('proof_of_delivery', Proof_DeliveryStatement ?? "")
    formData.append('bank_statement_2', BankStatement2Statement ?? null)
    formData.append('gst_paid_submission', GstPaidStatement ?? null)
    formData.append('mobile', BORROWERNUMBER ?? null)
    formData.append('expected_roi', expectedROI?.roi[1] ?? null)
    formData.append("company_establishment", inputValues?.company_establishment);
    formData.append("invoice_payment_date", inputValues?.invoice_payment_date);
    formData.append("credit_period", inputValues?.credit_period);
    formData.append("invoice_issue_date", inputValues?.invoice_issue_date);
    formData.append("avg_annual_turnover", inputValues?.avg_annual_turnover);
    formData.append("buss_premise_ownership", inputValues?.buss_premise_ownership);
    formData.append("itr_form16_password", inputValues?.itr_form16_password);
    formData.append("salary_slip_1_password", inputValues?.salary_slip_1_password);
    formData.append("bank_stmt1_password", inputValues?.bank_stmt1_password);
    formData.append("bank_stmt2_password", inputValues?.bank_stmt2_password);
    props.actions.createLoanAction(formData)
  }
  return (
    <>
        {(adminState?.getUserByToken?.loading || masterState?.getDropdownData?.loading || borrowerState?.getProductList?.loading || cpState?.createLoan?.loading) &&
            <div>
                <Loader />
            </div>
        }
        <Box className='dashboard_box bg_shadow'>
            <Grid className="main_grid_container align-items-center">
                <GridItem colSpan={8}>
                    <Heading as="h2" className='font-poppins page_heading'>Loan Application</Heading>
                </GridItem>
                <GridItem colSpan={4}>
                    <NavBar data={userData} isAdmin isCP />
                </GridItem>
            </Grid>
            <Box className='main_Kyc_form_container'>
                <Grid className="main_grid_container">
                    <GridItem colSpan={7}>
                        <Box mb={3} className='form_kyc_cp'>
                            <Box>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Select Loan Type</Heading>
                                <Select placeholder="Please Select Loan Type" variant="filled" className="font-poppins input_box_select"
                                    name="loan_type" onChange={handleChange} value={selectedLoanType?.product_id ?? ''}>
                                    {productData?.map((item, index) => {
                                        return (
                                            <option key={index} value={item.product_id}>{item.name}</option>
                                        )
                                    })}
                                </Select>
                            </Box>
                            <Box mt={4}>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Loan Amount</Heading>
                                <Input size="md" name="loan_amount"  type="text" placeholder="Please Enter Loan Amount" className="input_box font-poppins"
                                    onChange={handleChange} value={inputValues?.loan_amount ?? ''}
                                />
                            </Box>
                            {
                                selectedLoanType?.name == 'Invoice Financing Loan' &&
                                <Box>
                                <Box mt={4}>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Invoice Amount</Heading>
                                <Input size="md" name="invoice_amount"  type="text" placeholder="Please Enter 
                                invoice Amount" className="input_box font-poppins"
                                    onChange={handleChange} value={inputValues?.invoice_amount ?? ''}
                                />
                            </Box>
                            <Box mt={4}>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Date Of Issuance Of Invoice</Heading>
                                <Input size="md" name="invoice_issue_date"  type="date" placeholder="DD/MM/YYYY " className="input_box font-poppins"
                                    onChange={handleChange} value={moment(inputValues.invoice_issue_date).format('YYYY-MM-DD') ?? ""}
                                />
                            </Box>
                            <Box mt={4}>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Invoice Payment Date</Heading>
                                <Input size="md" name="invoice_payment_date"  type="date" placeholder="DD/MM/YYYY " className="input_box font-poppins"
                                    onChange={handleChange} value={moment(inputValues.invoice_payment_date).format('YYYY-MM-DD') ?? ""}
                                />
                            </Box>
                            <Box mt={4}>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Credit Period</Heading>
                                <Input size="md" name="credit_period"  type="number" placeholder="Please Enter Your Credit Period" className="input_box font-poppins"
                                    onChange={handleChange} value={inputValues?.credit_period ?? ""}
                                />
                            </Box>
                            </Box>
                            
                            }
                           
                           {loanTenureData?.length > 0 ?
                                <Box mt={4} className='form_inputs'>
                                    <Heading as="h5" className='font-poppins'>Loan Tenure<span>(Months)</span></Heading>
                                    <Box className='d-flex align-items-center col-gap-25'>
                                        <RangeSlider value={loanTenure} min={loanRange?.min_tenure} max={loanRange?.max_tenure} step={1}
                                            onChange={(e) => handleLoanTenure(e)} >
                                            <RangeSliderTrack className='range_slider_bg'>
                                                <RangeSliderFilledTrack bg='#BA1F33' />
                                            </RangeSliderTrack>
                                            <RangeSliderThumb boxSize={6} index={0} className='left_thumb' />
                                            <RangeSliderThumb boxSize={6} index={1} className='right_thumb' />
                                        </RangeSlider>
                                        <Box className='tenure_block'>
                                            <Heading as="h5" className='font-poppins'>{loanTenure[1]} Months</Heading>
                                        </Box>
                                    </Box>
                                </Box> : 
                                <Box mt={4}>
                                    <Heading as="h1" className="font-poppins label_heading" mb={1}>Loan Tenure</Heading>
                                    <Input size="md" name="loan_tenure"  type="text" placeholder={selectedLoanType?.payment_frequency === 0 ? "Please Enter Loan Tenure in Months":"Please Enter Loan Tenure in Days"} className="input_box font-poppins"
                                        onChange={handleChange} value={inputValues?.loan_tenure ?? ''}
                                    />
                                </Box>
                            }
                            {
                               (selectedLoanType?.name == 'Invoice Financing Loan' || selectedLoanType?.name == 'Business Loan') ?
                        <Box mt={4} className='form_inputs expected_roi'>
                        <Heading as="h5" className='font-poppins label_heading'>Expected ROI<span>(Range 23% to 41%)</span></Heading>
                        <Box className='d-flex align-items-center col-gap-25'>
                            <RangeSlider value={expectedROI?.roi} min={12} max={41} step={0.1}
                                onChange={(e) => handleExpectedROI(e, 'roi')} >
                                <RangeSliderTrack className='range_slider_bg'>
                                    <RangeSliderFilledTrack bg='#BA1F33' />
                                </RangeSliderTrack>
                                <RangeSliderThumb boxSize={6} index={0} className='left_thumb' />
                                <RangeSliderThumb boxSize={6} index={1} className='right_thumb' />
                            </RangeSlider>
                            <Box className='loan_block roi_data'>
                                <Heading as="h5" className='font-poppins'>{expectedROI?.roi[1]}%</Heading>
                            </Box>
                        </Box>
                    </Box>
                           :
                           <Box mt={4} className='form_inputs expected_roi'>
                           <Heading as="h5" className='font-poppins label_heading'>Expected ROI<span>(Range 12% to 36%)</span></Heading>
                           <Box className='d-flex align-items-center col-gap-25'>
                               <RangeSlider value={expectedROI?.roi} min={12} max={36} step={0.1}
                                   onChange={(e) => handleExpectedROI(e, 'roi')} >
                                   <RangeSliderTrack className='range_slider_bg'>
                                       <RangeSliderFilledTrack bg='#BA1F33' />
                                   </RangeSliderTrack>
                                   <RangeSliderThumb boxSize={6} index={0} className='left_thumb' />
                                   <RangeSliderThumb boxSize={6} index={1} className='right_thumb' />
                               </RangeSlider>
                               <Box className='loan_block roi_data'>
                                   <Heading as="h5" className='font-poppins'>{expectedROI?.roi[1]}%</Heading>
                               </Box>
                           </Box>
                           <GridItem colSpan={6}>
                                        <Heading as="h1" className="font-poppins label_heading" mb={1}>Education Qualification</Heading>
                                        <Select placeholder="Please Select Education Qualification" variant="filled" className="font-poppins input_box_select"
                                            name="educational_qualification" onChange={handleChange} value={inputValues?.educational_qualification ?? userData?.personal_data?.educational_qualification ?? ''}>
                                            {dropdownData?.educational_qualification?.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.key}>{item.value}</option>
                                                )
                                            })}
                                        </Select>
                                    </GridItem>
                       </Box>
                            }
                            {
                                (selectedLoanType?.name == 'Invoice Financing Loan' || selectedLoanType?.name == 'Business Loan'  )  ?
                                <Grid className="main_grid_container" mt={4}>
                                <GridItem colSpan={6}>
                                    <Heading as="h1" className="font-poppins label_heading" mb={1}>Business Premise Ownership</Heading>
                                    <Select placeholder="Please Select Business Premise Ownership " variant="filled" className="font-poppins input_box_select"
                                        name="buss_premise_ownership" onChange={handleChange} value={inputValues?.buss_premise_ownership ?? userData?.personal_data?.premise_status ?? ''}>
                                        {dropdownData?.buss_premise_ownership?.map((item, index) => {
                                            return (
                                                <option key={index} value={item.key}>{item.value}</option>
                                            )
                                        })}
                                    </Select>
                                </GridItem>
                                <GridItem colSpan={6}>
                                <Box mb={3} className='form_inputs label_heading'>
                                    <Heading as="h1" className='font-poppins label_heading' mb={1}>Average Annual Turnover</Heading>
                                    <Input size="md" name="avg_annual_turnover"  type="text" placeholder="Please Enter  Average Annual Turnover" className="input_box font-poppins"
                                        onChange={handleChange} value={inputValues?.avg_annual_turnover ?? ''}
                                    />
                                </Box>

                                </GridItem>
                                <GridItem colSpan={6} style={{width:"400px"}}>
                                {/* <Box mb={3} className='form_inputs label_heading'> */}
                                    <Heading as="h5" className='font-poppins label_heading' mb={1}>Work Experience /Company Establishment(In Months)</Heading>
                                    <Input size="md" name="company_establishment"  type="text" placeholder="Please Enter  Company Establishment In Months" className="input_box font-poppins"
                                        onChange={handleChange} value={inputValues?.company_establishment ?? ''}
                                    />
                                {/* </Box> */}
                                </GridItem>
                                {
                                    selectedLoanType?.name == 'Business Loan' &&
                                    <GridItem colSpan={6} mt={1}>
                                    <Heading as="h1" className="font-poppins label_heading" mt={0}>Loan Purpose</Heading>
                                    <Select placeholder="Please Select Loan Purpose" variant="filled" className="font-poppins input_box_select"
                                        name="loan_purpose" onChange={handleChange} value={inputValues?.loan_purpose ?? userData?.personal_data?.loan_purpose ?? ''}>
                                        {dropdownData?.loan_purpose?.map((item, index) => {
                                            return (
                                                <option key={index} value={item.value}>{item.value}</option>
                                            )
                                        })}
                                    </Select>
                                </GridItem>
                                }
                            </Grid>
                           
                                :
                                <Grid className="main_grid_container" mt={4}>
                                    <GridItem colSpan={6}>
                                        <Heading as="h1" className="font-poppins label_heading" mb={1}>House Ownership</Heading>
                                        <Select placeholder="Please Select Premise Ownership" variant="filled" className="font-poppins input_box_select"
                                            name="premise_status" onChange={handleChange} value={inputValues?.premise_status ?? userData?.personal_data?.premise_status ?? ''}>
                                            {dropdownData?.premise_status?.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.key}>{item.value}</option>
                                                )
                                            })}
                                        </Select>
                                    </GridItem>
                                <GridItem colSpan={6}>
                                    <Heading as="h1" className="font-poppins label_heading" mb={1}>Current Company Name</Heading>
                                    <Input size="md" name="current_company_name"  type="text" placeholder="Your Current Company Name" className="input_box font-poppins"
                                        onChange={handleChange} value={inputValues?.current_company_name ?? ''}
                                    />
                                </GridItem>
                                <GridItem colSpan={6}>
                                    <Heading as="h1" className="font-poppins label_heading" mb={1}>Company Sector</Heading>
                                    <Select placeholder="Please Select Company Sector" variant="filled" className="font-poppins input_box_select"
                                        name="company_sector" onChange={handleChange} value={inputValues?.company_sector ?? ''}>
                                        {dropdownData?.company_sector?.map((item, index) => {
                                            return (
                                                <option key={index} value={item.key}>{item.value}</option>
                                            )
                                        })}
                                    </Select>
                                </GridItem>
                                <GridItem colSpan={6}>
                                    <Heading as="h1" className="font-poppins label_heading" mb={1}>Net Monthly Income</Heading>
                                    <Input size="md" name="monthly_income"  type="number" onKeyDown={preventInvalidKey} placeholder="Please Enter Your Net Monthly Income" className="input_box font-poppins"
                                    onChange={handleChange} value={inputValues?.monthly_income ?? ''}
                                />
                                </GridItem>
                            <GridItem colSpan={6}>
                            <Box mt={4}>
                                <Heading as="h1" className="font-poppins label_heading" mb={1}>Total Work Experience</Heading>
                                <Select placeholder="Please Select Your Total Work Experience Range" variant="filled" className="font-poppins input_box_select"
                                    name="work_experience" onChange={handleChange} value={inputValues?.work_experience ?? ''}>
                                    {dropdownData?.work_exp_level?.map((item, index) => {
                                        return (
                                            <option key={index} value={item.key}>{item.value}</option>
                                        )
                                    })}
                                </Select>
                            </Box>
                            </GridItem>
                            <GridItem colSpan={6} mt={4}>
                                        <Heading as="h1" className="font-poppins label_heading" mb={1}>Loan Purpose</Heading>
                                        <Select placeholder="Please Select Loan Purpose" variant="filled" className="font-poppins input_box_select"
                                            name="loan_purpose" onChange={handleChange} value={inputValues?.loan_purpose ?? userData?.personal_data?.loan_purpose ?? ''}>
                                            {dropdownData?.loan_purpose?.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.value}>{item.value}</option>
                                                )
                                            })}
                                        </Select>
                                    </GridItem>
                                </Grid>
                            }
                           
                          
                            {selectedLoanType?.name === 'Insta Loan' ? null :
                                <Box mt={6} className='borrow_credit_score'>
                                    <Heading as="h1" className="font-poppins">Upload Documents</Heading>
                                    <Grid className="main_grid_container documents_grid_wrapper" mt={4}>
                                     
                                        {
                                          // (selectedLoanType?.name == 'Bullet Loan'  ||   selectedLoanType?.name == 'Personal Loan' || selectedLoanType?.name == 'Personal Loan' || selectedLoanType?.name == 'OneNDF Personal Loan' || selectedLoanType?.name == 'Dhanrashi Salaried Loan' || selectedLoanType?.name == 'Lendingpark Pre-Approved PL' || selectedLoanType?.name == 'CCL-IK-DRAWDOWN-2024' || selectedLoanType?.name == 'BIGLOAN Personal Loan' || selectedLoanType?.name == 'Lendingpark Pre-Approved BL'  || selectedLoanType?.name == 'FINKEDA LIMITED LOAN'  || selectedLoanType?.name == 'AM10k180'  || selectedLoanType?.name == 'AM15K180' || selectedLoanType?.name == 'AM20k360' || selectedLoanType?.name == 'AM25k360' || selectedLoanType?.name == 'AM30k360' ) &&
                                          ( employmentType == 1 || employmentType == 2) &&
                                           <>
                                           
                                           <GridItem colSpan={6}>
                                            <Box className='form_inputs_kyc_cp'>
                                                <Heading as="h5" className='font-poppins'>Income Proof</Heading>
                                                <Box>
                                                    <CustomButton
                                                        className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                        title="Browse"
                                                        onClick={() => showOpenFileDialog('income_proof')}
                                                        leftIcon={<Image src={AddIcon} />}
                                                    />
                                                    <Input
                                                        size="md"
                                                        name="upload"
                                                        type="file"
                                                        accept=".pdf"
                                                        onChange={(e) => onChangeFile(e, 'income_proof')}
                                                        className="d-none"
                                                        ref={incomeRef}
                                                    />
                                                    <Text className='font-poppins note file_name'>{incomeStatement?.name}</Text>
                                                    <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={handleChange}
                                                    mt={4}
                                                    name="salary_slip_1_password"
                                                    value={inputValues?.salary_slip_1_password ?? ''}
                                                />
                                                </Box>
                                            </Box>
                                        </GridItem>
                                           <GridItem colSpan={6}>
                                           <Box className='form_inputs_kyc_cp'>
                                           <Heading as="h5" className='font-poppins'>Bank Statement</Heading>
                                               
                                               <Box>
                                                   <CustomButton
                                                       className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                       title="Browse"
                                                       onClick={() => showOpenFileDialog('bank_statement')}
                                                       leftIcon={<Image src={AddIcon} />}
                                                   />
                                                   <Input
                                                       size="md"
                                                       name="upload"
                                                       type="file"
                                                       accept=".pdf"
                                                       onChange={(e) => onChangeFile(e, 'bank_statement')}
                                                       className="d-none"
                                                       ref={bankRef}
                                                   />
                                                   <Text className='font-poppins note file_name'>{bankStatement?.name}</Text>
                                                    <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={handleChange}
                                                    mt={4}
                                                    name="bank_stmt1_password"
                                                    value={inputValues?.bank_stmt1_password ?? ''}

                                                />
                                               </Box>
                                           </Box>
                                       </GridItem>
                                           </>
                                         
                                        }
                                        
                                        <GridItem colSpan={6}>
                                            <Box className='form_inputs_kyc_cp'>
                                                {
                                                    (selectedLoanType?.name == 'Invoice Financing Loan' || selectedLoanType?.name == 'Business Loan') ?
                                                    <Heading as="h5" className='font-poppins'>ITR </Heading>
                                                    :
                                                    <Heading as="h5" className='font-poppins'>ITR <span>(Optional)</span></Heading>
                                                }

                                                <Box>
                                                    <CustomButton
                                                        className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                        title="Browse"
                                                        onClick={() => showOpenFileDialog('itr_proof')}
                                                        leftIcon={<Image src={AddIcon} />}
                                                    />
                                                    <Input
                                                        size="md"
                                                        name="upload"
                                                        type="file"
                                                        accept=".pdf"
                                                        onChange={(e) => onChangeFile(e, 'itr_proof')}
                                                        className="d-none"
                                                        ref={itrRef}
                                                    />
                                                    <Text className='font-poppins note file_name'>{itrStatement?.name}</Text>
                                                    <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={handleChange}
                                                    name="itr_form16_password"
                                                    value={inputValues?.itr_form16_password ?? ''}
                                                    mt={4}
                                                />
                                                </Box>
                                            </Box>
                                        </GridItem>
                                        <GridItem colSpan={6}>
                                            <Box className='form_inputs_kyc_cp'>
                                            {
                                                    (selectedLoanType?.name == 'Invoice Financing Loan' || selectedLoanType?.name == 'Business Loan') ?
                                                    <Heading as="h5" className='font-poppins'>CP  Assessment <span>(Optional)</span></Heading>

                                                    :
                                                    <Heading as="h5" className='font-poppins'>CP Credit Assessment <span>(Optional)</span></Heading>

                                                }
                                                <Box>
                                                    <CustomButton
                                                        className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                        title="Browse"
                                                        onClick={() => showOpenFileDialog('cp_assesment')}
                                                        leftIcon={<Image src={AddIcon} />}
                                                    />
                                                    <Input
                                                        size="md"
                                                        name="upload"
                                                        type="file"
                                                        accept=".pdf"
                                                        onChange={(e) => onChangeFile(e, 'cp_assesment')}
                                                        className="d-none"
                                                        ref={cpAssesmentRef}
                                                    />
                                                    <Text className='font-poppins note file_name'>{cpAssesment?.name}</Text>
                                                </Box>
                                            </Box>
                                        </GridItem>
                                        <GridItem colSpan={6}>
                                            <Box className='form_inputs_kyc_cp'>
                                                <Heading as="h5" className='font-poppins'>Post Dated Cheque <span>(Optional)</span></Heading>
                                                <Box>
                                                    <CustomButton
                                                        className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                        title="Browse"
                                                        onClick={() => showOpenFileDialog('pdc')}
                                                        leftIcon={<Image src={AddIcon} />}
                                                    />
                                                    <Input
                                                        size="md"
                                                        name="upload"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => onChangeFile(e, 'pdc')}
                                                        className="d-none"
                                                        ref={pdcRef}
                                                    />
                                                    <Text className='font-poppins note file_name'>{pdcData?.name}</Text>
                                                </Box>
                                            </Box>
                                        </GridItem>
                                      {
                                         selectedLoanType?.name === 'Invoice Financing Loan' &&
                                        <>
                                         
                                           <GridItem colSpan={6}>
                                           <Box className='form_inputs_kyc_cp'>
                                           <Heading as="h5" className='font-poppins'>Bank Statement<span>(Current Financial Year till Date)</span></Heading>
                                               
                                               <Box>
                                                   <CustomButton
                                                       className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                       title="Browse"
                                                       onClick={() => showOpenFileDialog('bank_statement')}
                                                       leftIcon={<Image src={AddIcon} />}
                                                   />
                                                   <Input
                                                       size="md"
                                                       name="upload"
                                                       type="file"
                                                       accept=".pdf"
                                                       onChange={(e) => onChangeFile(e, 'bank_statement')}
                                                       className="d-none"
                                                       ref={bankRef}
                                                   />
                                                   <Text className='font-poppins note file_name'>{bankStatement?.name}</Text>
                                                   <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="bank_stmt1_password"
                                                    value={props?.inputValues?.bank_stmt1_password ?? ''}
                                                />
                                               </Box>
                                           </Box>
                                       </GridItem>
                                         <GridItem colSpan={6}>
                                        <Box className='form_inputs_kyc_cp'>
                            <Heading as="h5" className="font-poppins ">Invoice Copies
                  <Tooltip label="Copies of all invoices to be financed clubbed in a single document duly verified and accepted by the customer."  hasArrow fontSize='xs' placement='bottom-start'>
                    <InfoOutlineIcon ml={1} />
                  </Tooltip>
                </Heading>
                            <Box>
                                <CustomButton
                                    className="btn_transparent_red font-poppins col-gap-10 w-100"
                                    title="Browse"
                                    onClick={() => showOpenFileDialog('invoice_copy')}
                                    leftIcon={<Image src={AddIcon} />}
                                />
                                <Input
                                    size="md"
                                    name="upload"
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => onChangeFile(e, 'invoice_copy')}
                                    className="d-none"
                                    ref={InvoiceRef}
                                />
                                <Text className='font-poppins note file_name'>{InvoiceStatement?.name}</Text>
                            </Box>
                        </Box>
                                        </GridItem>
                                        <GridItem colSpan={6}>
                                        <Box className='form_inputs_kyc_cp'>
                             <Heading as="h5" className="font-poppins">Proof Of Delivery (Optional)
                   <Tooltip label="AVERAGE Annual Turnover (Preceding Financial year)"  hasArrow fontSize='xs' placement='bottom-start'>
                     <InfoOutlineIcon ml={1} />
                   </Tooltip>
                 </Heading>
                             <Box>
                                 <CustomButton
                                     className="btn_transparent_red font-poppins col-gap-10 w-100"
                                     title="Browse"
                                     onClick={() => showOpenFileDialog('proof_of_delivery')}
                                     leftIcon={<Image src={AddIcon} />}
                                 />
                                 <Input
                                     size="md"
                                     name="upload"
                                     type="file"
                                     accept=".pdf"
                                     onChange={(e) => onChangeFile(e, 'proof_of_delivery')}
                                     className="d-none"
                                     ref={PrrofdelliveryRef}
                                 />
                                 <Text className='font-poppins note file_name'>{Proof_DeliveryStatement?.name}</Text>
                             </Box>
                         </Box>
                                        </GridItem>
                                        <GridItem colSpan={6}>
                                        <Box className='form_inputs_upload form_inputs' width="323px">
                        <Heading as="h5" className='font-poppins'>Bank Statement<span>(Preceding Financial year)</span></Heading>
                        <Box>
                            <CustomButton
                                className="btn_transparent_red font-poppins col-gap-10 w-100"
                                title="Browse"
                                onClick={() => showOpenFileDialog('bank_statement_2')}
                                leftIcon={<Image src={AddIcon} />}
                            />
                            <Input
                                size="md"
                                name="upload"
                                type="file"
                                accept=".pdf"
                                onChange={(e) => onChangeFile(e, 'bank_statement_2')}
                                className="d-none"
                                ref={BankStatRef}
                            />
                            <Text className='font-poppins note file_name'>{BankStatement2Statement?.name}</Text>
                            <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="bank_stmt2_password"
                                                    value={props?.inputValues?.bank_stmt2_password ?? ''}
                                                />
                        </Box>
                    </Box>
                                        </GridItem>
                                         <GridItem colSpan={6}>
                                         <Box className='form_inputs_kyc_cp'>
                                                 <Heading as="h5" className="font-poppins">GST Submission
                                       <Tooltip label="GST submissions for the preceding 12 months at the time of application."  hasArrow fontSize='xs' placement='bottom-start'>
                                         <InfoOutlineIcon ml={1} />
                                       </Tooltip>
                                     </Heading>
                                                 <Box>
                                                     <CustomButton
                                                         className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                         title="Browse"
                                                         onClick={() => showOpenFileDialog('gst_paid_submission')}
                                                         leftIcon={<Image src={AddIcon} />}
                                                     />
                                                     <Input
                                                         size="md"
                                                         name="upload"
                                                         type="file"
                                                         accept=".pdf"
                                                         onChange={(e) => onChangeFile(e, 'gst_paid_submission')}
                                                         className="d-none"
                                                         ref={gstSubmissionRef}
                                                     />
                                                     <Text className='font-poppins note file_name'>{GstPaidStatement?.name}</Text>
                                                 </Box>
                                           
                                            
                                      </Box>
                                                                 </GridItem>
                                        </>
                                   
                                      }
                                      {
                                         selectedLoanType?.name === 'Business Loan' &&
                                        <>
                                         
                                           <GridItem colSpan={6}>
                                           <Box className='form_inputs_kyc_cp'>
                                           <Heading as="h5" className='font-poppins'>Bank Statement<span>(Current Financial Year till Date)</span></Heading>
                                               
                                               <Box>
                                                   <CustomButton
                                                       className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                       title="Browse"
                                                       onClick={() => showOpenFileDialog('bank_statement')}
                                                       leftIcon={<Image src={AddIcon} />}
                                                   />
                                                   <Input
                                                       size="md"
                                                       name="upload"
                                                       type="file"
                                                       accept=".pdf"
                                                       onChange={(e) => onChangeFile(e, 'bank_statement')}
                                                       className="d-none"
                                                       ref={bankRef}
                                                   />
                                                   <Text className='font-poppins note file_name'>{bankStatement?.name}</Text>
                                                   <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="bank_stmt1_password"
                                                    value={props?.inputValues?.bank_stmt1_password ?? ''}
                                                />
                                               </Box>
                                           </Box>
                                       </GridItem>
                                        <GridItem colSpan={6}>
                                        <Box className='form_inputs_upload form_inputs' width="323px">
                        <Heading as="h5" className='font-poppins'>Bank Statement<span>(Preceding Financial year)</span></Heading>
                        <Box>
                            <CustomButton
                                className="btn_transparent_red font-poppins col-gap-10 w-100"
                                title="Browse"
                                onClick={() => showOpenFileDialog('bank_statement_2')}
                                leftIcon={<Image src={AddIcon} />}
                            />
                            <Input
                                size="md"
                                name="upload"
                                type="file"
                                accept=".pdf"
                                onChange={(e) => onChangeFile(e, 'bank_statement_2')}
                                className="d-none"
                                ref={BankStatRef}
                            />
                            <Text className='font-poppins note file_name'>{BankStatement2Statement?.name}</Text>
                            <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="bank_stmt2_password"
                                                    value={props?.inputValues?.bank_stmt2_password ?? ''}
                                                />
                        </Box>
                    </Box>
                                        </GridItem>
                                           <GridItem colSpan={6}>
                                           <Box className='form_inputs_kyc_cp'>
                                                   <Heading as="h5" className="font-poppins">GST Submission
                                         <Tooltip label="GST submissions for the preceding 12 months at the time of application."  hasArrow fontSize='xs' placement='bottom-start'>
                                           <InfoOutlineIcon ml={1} />
                                         </Tooltip>
                                       </Heading>
                                                   <Box>
                                                       <CustomButton
                                                           className="btn_transparent_red font-poppins col-gap-10 w-100"
                                                           title="Browse"
                                                           onClick={() => showOpenFileDialog('gst_paid_submission')}
                                                           leftIcon={<Image src={AddIcon} />}
                                                       />
                                                       <Input
                                                           size="md"
                                                           name="upload"
                                                           type="file"
                                                           accept=".pdf"
                                                           onChange={(e) => onChangeFile(e, 'gst_paid_submission')}
                                                           className="d-none"
                                                           ref={gstSubmissionRef}
                                                       />
                                                       <Text className='font-poppins note file_name'>{GstPaidStatement?.name}</Text>
                                                   </Box>
                                             
                                              
                                        </Box>
                                                                   </GridItem>
                                        </>
                                      }
                                    </Grid>
                                 
                                </Box>
                                
                            }
                        </Box>
                    </GridItem>
                    <GridItem colSpan={1}></GridItem>
                    <GridItem colSpan={4}>
                        <Box className='borrow_credit_score'>
                            <Heading as="h1" mb={4} className='font-poppins'>Borrower Name : {BORROWERNAME}</Heading>
                            <Heading as="h1" className='font-poppins'>Borrower’s Credit Score</Heading>
                            <Box className='credit_score bg_shadow' mt={3}>
                                <Box mb={4} className='d-flex align-items-center justify-content-between score_flex'>
                                    <Heading as="h2" className='font-poppins w-auto'>Credit Score</Heading>
                                    <Heading as="p" className='font-poppins'>Powered By<Image src={EquifaxIcon} /></Heading>
                                </Box>
                            <Box className="scoreMeter">
                                <Box className={`meterArrow value-${score}`} style={{ transform: `rotate(${rotationNumber}deg)` }}></Box>
                                    <Box className="meterScore">
                                        <Heading as="h2" className='font-poppins score'>{score} </Heading>
                                        <Heading as="h2" className={`font-poppins scoreBand ${className}`}>{text}</Heading>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </GridItem>
                </Grid>
                <Box className="kyc_actions">
                    <CustomButton size="md" type="submit" title="Submit Loan Application" className="btn_theme font-poppins" onClick={()=>handleValidatedLoanApply(selectedLoanType?.max_tenure_limit)} />
                 </Box>
            </Box>
        </Box>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(OnBoardApplyLoan)